module.exports = __webpack_public_path__ + "img/dome-footer.5d1654b4.png";